module.exports = __webpack_public_path__ + "img/092.cac2ee26.png";